import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-html-wrapper',
  templateUrl: './html-wrapper.component.html',
  styleUrls: ['./html-wrapper.component.scss']
})
export class HtmlWrapperComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Input("content") content = "";
}
